import React, { useState } from 'react';

// Watch photo for report cards/hero. Only token-based report pages can resolve
// photos (the signing endpoint is token-gated); the private /analytics path and
// any watch without a photo fall back to the placeholder glyph.
//
// hasPhoto (tri-state): false → render the glyph WITHOUT hitting the photo
// endpoint (saves a guaranteed-404 Vercel invocation per photoless watch once
// the collection RPC ships its has_photo flag); true/undefined → request and
// fall back on error, so pages work unchanged until the flag exists.
export default function ReportThumb({ token, watchId, big = false, hasPhoto, photoUrl }) {
  const [failed, setFailed] = useState(false);
  const cls = `rpt-thumb${big ? ' rpt-thumb--big' : ''}`;
  // photoUrl: a plain public image (the example report's bundled photos) —
  // no token needed.
  if (photoUrl && !failed) {
    return <img className={cls} alt="" loading="lazy" src={photoUrl} onError={() => setFailed(true)} />;
  }
  if (!token || failed || hasPhoto === false) {
    return <div className={cls} aria-hidden="true">⌚︎</div>;
  }
  return (
    <img
      className={cls}
      alt=""
      loading="lazy"
      src={`/api/watch-photo?token=${encodeURIComponent(token)}&watch=${encodeURIComponent(watchId)}`}
      onError={() => setFailed(true)}
    />
  );
}
